import './vendor/jquery.elevateZoom-3.0.8.min';
import './vendor/objectFitPolyfill.min.js';
import './vendor/twitterFetcher_min.js';
import './navigation.js';

function isTouchDevice() {
    return (('ontouchstart' in window) ||
       (navigator.maxTouchPoints > 0) ||
       (navigator.msMaxTouchPoints > 0));
  }

// noinspection JSJQueryEfficiency

/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */

( function() {
	var isIe = /(trident|msie)/i.test( navigator.userAgent );

	if ( isIe && document.getElementById && window.addEventListener ) {
		window.addEventListener( 'hashchange', function() {
			var id = location.hash.substring( 1 ),
				element;

			if ( ! ( /^[A-z0-9_-]+$/.test( id ) ) ) {
				return;
			}

			element = document.getElementById( id );

			if ( element ) {
				if ( ! ( /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) ) {
					element.tabIndex = -1;
				}

				element.focus();
			}
		}, false );
	}
} )();

(function addPointerClasses() {
    var is_touch_event = false;

    function hasMouse() {
        if(is_touch_event === false) {
            document.documentElement.classList.add('mouse');
            document.body.removeEventListener('mousemove', hasMouse);
        }
    }

    document.body.addEventListener('mousemove', hasMouse);

    document.body.addEventListener('touchstart', function ()  {
        is_touch_event = true;
    });
    document.body.addEventListener('touchend', function ()  {
        is_touch_event = false;
    });
    document.body.addEventListener('click', function ()  {
        if(is_touch_event) is_touch_event = false;
    });

    function isTouchDevice() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }

    if(isTouchDevice()) {
        document.documentElement.classList.add('touch');
    }
})();

function number_format (number, decimals, decPoint, thousandsSep) { // eslint-disable-line camelcase
  //  discuss at: http://locutus.io/php/number_format/
  // original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
  // improved by: Kevin van Zonneveld (http://kvz.io)
  // improved by: davook
  // improved by: Brett Zamir (http://brett-zamir.me)
  // improved by: Brett Zamir (http://brett-zamir.me)
  // improved by: Theriault (https://github.com/Theriault)
  // improved by: Kevin van Zonneveld (http://kvz.io)
  // bugfixed by: Michael White (http://getsprink.com)
  // bugfixed by: Benjamin Lupton
  // bugfixed by: Allan Jensen (http://www.winternet.no)
  // bugfixed by: Howard Yeend
  // bugfixed by: Diogo Resende
  // bugfixed by: Rival
  // bugfixed by: Brett Zamir (http://brett-zamir.me)
  //  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
  //  revised by: Luke Smith (http://lucassmith.name)
  //    input by: Kheang Hok Chin (http://www.distantia.ca/)
  //    input by: Jay Klehr
  //    input by: Amir Habibi (http://www.residence-mixte.com/)
  //    input by: Amirouche
  //   example 1: number_format(1234.56)
  //   returns 1: '1,235'
  //   example 2: number_format(1234.56, 2, ',', ' ')
  //   returns 2: '1 234,56'
  //   example 3: number_format(1234.5678, 2, '.', '')
  //   returns 3: '1234.57'
  //   example 4: number_format(67, 2, ',', '.')
  //   returns 4: '67,00'
  //   example 5: number_format(1000)
  //   returns 5: '1,000'
  //   example 6: number_format(67.311, 2)
  //   returns 6: '67.31'
  //   example 7: number_format(1000.55, 1)
  //   returns 7: '1,000.6'
  //   example 8: number_format(67000, 5, ',', '.')
  //   returns 8: '67.000,00000'
  //   example 9: number_format(0.9, 0)
  //   returns 9: '1'
  //  example 10: number_format('1.20', 2)
  //  returns 10: '1.20'
  //  example 11: number_format('1.20', 4)
  //  returns 11: '1.2000'
  //  example 12: number_format('1.2000', 3)
  //  returns 12: '1.200'
  //  example 13: number_format('1 000,50', 2, '.', ' ')
  //  returns 13: '100 050.00'
  //  example 14: number_format(1e-8, 8, '.', '')
  //  returns 14: '0.00000001'
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number;
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
  var dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
  var s = '';
  var toFixedFix = function (n, prec) {
    var k = Math.pow(10, prec);
    return '' + (Math.round(n * k) / k)
      .toFixed(prec);
  };
  // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

var slideTimer, timerRemaining;
var slideTime = 7500; // was 15000
var sliding = false;
var totalSlides = 0;

function slideRight() {
    if (!sliding) {
        sliding = true;
        clearInterval(slideTimer);
        jQuery('.hero-slider .slides .slide.prev, .hero-slider .slides .slide.active, .hero-slider .slides .slide.next').addClass('slideRight');
        window.setTimeout(function(){
            if (totalSlides > 2) {
                var prevSlide = jQuery('.hero-slider .slides .slide.prev').clone();
            } else {
                var prevSlide = jQuery('.hero-slider .slides .slide.active').clone();
            }
            prevSlide.removeClass('prev').removeClass('next').removeClass('active').removeClass('slideRight');
            jQuery('.hero-slider .slides .slide.prev').remove();
            jQuery('.hero-slider .slides').append(prevSlide);
            jQuery('.hero-slider .slides .slide.active').removeClass('active').addClass('prev').removeClass('slideRight');
            jQuery('.hero-slider .slides .slide.next').removeClass('next').addClass('active').removeClass('slideRight');
            setupSlider();
        }, 400);
    }
}

function slideLeft() {
    if (!sliding) {
        sliding = true;
        clearInterval(slideTimer);
        jQuery('.hero-slider .slides .slide.prev, .hero-slider .slides .slide.active, .hero-slider .slides .slide.next').addClass('slideLeft');
        window.setTimeout(function(){
            if (totalSlides > 2) {
                var lastSlide = jQuery('.hero-slider .slides .slide:last-child').clone();
            } else {
                var lastSlide = jQuery('.hero-slider .slides .slide.active').clone();
            }
            lastSlide.addClass('prev').removeClass('next').removeClass('active').removeClass('slideLeft');
            if (jQuery('.hero-slider .slides').children().length > 1) {
                jQuery('.hero-slider .slides .slide:last-child').remove();
            }
            jQuery('.hero-slider .slides .slide.next').removeClass('next').removeClass('slideLeft');
            jQuery('.hero-slider .slides .slide.active').removeClass('active').addClass('next').removeClass('slideLeft');
            jQuery('.hero-slider .slides .slide.prev').removeClass('prev').addClass('active').removeClass('slideLeft');
            jQuery('.hero-slider .slides').prepend(lastSlide);
            setupSlider();
        }, 400);
    }
}

function setupSlider(init) {
    init = typeof init !== 'undefined' ? init : false;
    if (init) {
        totalSlides = jQuery('.hero-slider .slides .slide').length;
        if (totalSlides > 1) {
            jQuery('#home-hero .slide-nav').addClass('active');
            jQuery('.hero-slider .slides .slide:first-child').addClass('active');
        }
        jQuery('#home-hero .slide-nav a.prev').on('click', function(e){
            slideLeft();
            e.preventDefault();
        });
        jQuery('#home-hero .slide-nav a.next').on('click', function(e){
            slideRight();
            e.preventDefault();
        });
    }
    if (totalSlides > 1) {
        if (!jQuery('.hero-slider .slides .slide.active').prev().length) {
            var lastSlide = jQuery('.hero-slider .slides .slide:last-child').clone();
            jQuery('.hero-slider .slides').prepend(lastSlide);
            if (jQuery('.hero-slider .slides').children().length > 1) {
                jQuery('.hero-slider .slides .slide:last-child').remove();
            }
            jQuery('.hero-slider .slides .slide:first').removeClass('active').addClass('prev');
        }

        if (!jQuery('.hero-slider .slides .slide.active').next().length) {
            var firstSlide = jQuery('.hero-slider .slides .slide:first-child').clone();
            firstSlide.removeClass('prev');
            jQuery('.hero-slider .slides').append(firstSlide);
        }
        jQuery('.hero-slider .slides .slide.active').next().addClass('next');
        sliding = false;
        slideTimer = setInterval(function(){
            slideRight();
        }, slideTime);
    }
}

(jQuery(function($){

    if (jQuery('.hero-slider').length) {
        setupSlider(true);
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    // function checkNavTop() {
    //     if (!jQuery('#site-navigation').hasClass('fixed')) {
    //         jQuery('#site-navigation').data('scrolltop', jQuery('#site-navigation').position().top);
    //     } else {
    //         if (jQuery('body').hasClass('admin-bar')) {
    //             jQuery('#site-navigation').data('scrolltop', (jQuery('#site-navigation-spacer').position().top + jQuery('#wpadminbar').height()));
    //         } else {
    //             jQuery('#site-navigation').data('scrolltop', jQuery('#site-navigation-spacer').position().top);
    //         }
    //     }
    // }

    //override for woocommerce error slide position.

    jQuery('.woocommerce-checkout').on('submit', function(){
        var origOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function() {
            this.addEventListener('load', function() {
                var data = JSON.parse(this.responseText);
                if ( 'failure' === data.result ) {
                    // Scroll to top
                    jQuery( 'html, body' ).stop().animate( {
                        scrollTop: ( jQuery( 'form.checkout' ).offset().top - 210 )
                    }, 1000 );
                }
            });
            origOpen.apply(this, arguments);
        };
    });

    jQuery('.get-in-touch-register-btn').bind('click', function(e){
        jQuery('body').toggleClass('overlay-active');
        e.preventDefault();
    });


    function resizeProductImageZoomer() {
        if (jQuery('.gallery-main-image .zoomWrapper').length) {
            if (jQuery('.gallery-main-image').is(':visible')) {
                // console.log('found');
                var elem = jQuery('.gallery-main-image .zoomWrapper');
                elem.css({"height":elem.parent().outerHeight(), "width":elem.parent().outerWidth()});
                jQuery('.zoomContainer').css({"left": elem.offset().left, "top": elem.offset().top, "height":elem.parent().outerHeight(), "width":elem.parent().outerWidth()});
            }
        }
    }
    jQuery(window).on('scroll', function(){
        // if (!jQuery('#site-navigation').hasClass('fixed')) {
        //     if (!jQuery('#site-navigation').data('scrolltop')) {
        //         checkNavTop();
        //     } else {
        //         if (jQuery(window).scrollTop() > jQuery('#site-navigation').data('scrolltop') && jQuery(window).width() > 1050) {
        //             var spacer = jQuery('<div id="site-navigation-spacer">');
        //             spacer.css({"height":jQuery('#site-navigation').height() + 'px'});
        //             jQuery('#site-navigation').after(spacer);
        //             jQuery('#site-navigation').addClass('fixed');
        //         }
        //     }
        // } else {
        //     if (jQuery(window).scrollTop() < jQuery('#site-navigation').data('scrolltop')) {
        //         jQuery('#site-navigation').removeClass('fixed');
        //         jQuery('#site-navigation-spacer').remove();
        //     }
        // }
    });
    jQuery(window).on('resize', function() {
        // checkNavTop();
        resizeProductImageZoomer();
    });
    jQuery('#mega-menu li').bind('mouseenter', function(){
        if (jQuery(this).find('.sub-menu-wrap').length) {
            jQuery(this).addClass('active-hover');
        }
    }).bind('mouseleave', function(){
        if (jQuery(this).find('.sub-menu-wrap').length) {
            jQuery(this).removeClass('active-hover');
        }
    });
    jQuery('#mega-menu li a').bind('click', function(e){
        if (jQuery(this).parent().hasClass('has-sub-menu') && !jQuery(this).parent().hasClass('section-title')) {
            e.preventDefault();
        }
    });
    jQuery('.footer-to-top a').bind('click', function(e){
        e.preventDefault();
        jQuery('body,html').animate({
			scrollTop: 0
		}, 800);
    });
    jQuery('.phone-menu-toggle').bind('click', function(e){
        jQuery("body").toggleClass('menu-active');
        e.preventDefault();
    });
    jQuery("#click-dismisser, #site-navigation .mobile-close a, #get-in-touch-register-overlay a.close-me, #enquiry-form-overlay a.close-me").bind('click', function(e){
        if (jQuery("body").hasClass('menu-active')) {
            jQuery("body").toggleClass('menu-active');
        }
        if (jQuery("body").hasClass('overlay-active')) {
            jQuery("body").toggleClass('overlay-active');
        }
        if (jQuery('#input_5_12').length) {
            jQuery("#input_5_12").val('');
        }
        if (jQuery(e.target).hasClass('dismiss-for-good')) {
            setCookie('dismissed-modal', 1, 365);
        }
        e.preventDefault();
    });
    jQuery(".header-search a").bind('click', function(e) {
        jQuery('.search-input').parents('.header-search').toggleClass('active');
        e.preventDefault();
    });
    if (jQuery("#twitter-feed-js").length) {
        var configProfile = {
          "profile": {"screenName": 'bhamoptical'},
          "domId": 'twitter-feed-js',
          "maxTweets": 1,
          "enableLinks": true,
          "showUser": true,
          "showTime": false,
          "showImages": false,
          "showRetweet": false,
          "lang": 'en'
        };
        twitterFetcher.fetch(configProfile);
    }
    if (jQuery("#category-refine").length) {
        jQuery("#category-refine").bind('change', function(e){
            window.location.href = jQuery(this).val();
            e.preventDefault();
        });
    }
    if (jQuery('.enquire-form-link').length) {
        jQuery('.enquire-form-link').bind('click', function(e){
            jQuery('body').toggleClass('overlay-active');
            var name = jQuery(this).attr('data-name');
            var sku = jQuery(this).attr('data-sku');
            var offer = jQuery(this).attr('data-offer-name');
            if (name && jQuery('#input_5_7').length) {
                jQuery("#input_5_7").val(name);
            }
            if (sku && jQuery('#input_5_8').length) {
                jQuery("#input_5_8").val(sku);
            }
            if (offer && jQuery('#input_5_12').length) {
                jQuery("#input_5_12").val(offer);
            }
            e.preventDefault();
        });
    }

    // Video Thumb click

    // Image Thumb click
    jQuery('.product-gallery-right .gallery-thumbs ul li .image a').bind('click', function(e){
        console.log('CLICK');

        if (jQuery('.gallery-main-image').hasClass('has-video') && !jQuery('.gallery-main-image').hasClass('is-visible')) {
            jQuery('.gallery-main-image').addClass('is-visible');
            jQuery('.gallery-main-video').addClass('is-hidden');
            resizeProductImageZoomer();
            if (player) {
                player.pauseVideo();
            }
        }

    });
    jQuery("#zoom_01").elevateZoom({gallery:'gallery_01', cursor: 'pointer', galleryActiveClass: "active", imageCrossfade: true, zoomType : "lens", lensShape : "round", lensSize : 200});

    if(jQuery('[data-video_id]').length) {
        jQuery('[data-video_id]').on('click', function(e) {
            let video_id = jQuery(this).data('video_id');
            let video_type = jQuery(this).data('video-type');

            if (jQuery('.gallery-main-video').hasClass('is-hidden')) {
                jQuery('.gallery-main-image').removeClass('is-visible');
                jQuery('.gallery-main-video').removeClass('is-hidden');
            }

            galleryChange(video_type, video_id);

            e.preventDefault();
        });
    }

    function galleryChange(video_type, video_id) {
        let newVideoHTML = '';

        // let video_type = $(this).find('.gallery-main-video').data('video-type');
        console.log(video_type);
        console.log(video_id);

        if(video_type === 'youtube') {
            if (player) {
                player.loadVideoById(video_id);
            }
            // newVideoHTML = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + video_id + '?rel=0&amp;controls=1&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
        } else {
            newVideoHTML = '<script id="video_to_load" src="//fast.wistia.com/embed/medias/[VIDEO_ID].jsonp" async></script>' + "\n"
                + '<script src="//fast.wistia.com/assets/external/E-v1.js" async></script>' + "\n"
                + '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;">' + "\n"
                + '<div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">' + "\n"
                + '<div class="wistia_embed wistia_async_[VIDEO_ID] seo=false videoFoam=true" style="height:100%;width:100%">&nbsp;</div></div></div>';
        }

        jQuery("#zoom_01").elevateZoom({gallery:'gallery_01', cursor: 'pointer', galleryActiveClass: "active", imageCrossfade: true, zoomType : "lens", lensShape : "round", lensSize : 200});

        if (jQuery('.gallery-main-image').hasClass('has-video') && !jQuery('.gallery-main-image').hasClass('is-visible')) {
            jQuery('.gallery-main-image').addClass('is-visible');
            jQuery('.gallery-main-video').addClass('is-hidden');
            resizeProductImageZoomer();
        }

        if (jQuery('.gallery-main-video').hasClass('is-hidden')) {
            jQuery('.gallery-main-image').removeClass('is-visible');
            jQuery('.gallery-main-video').removeClass('is-hidden');
        }

        let theHTML = newVideoHTML;
        theHTML = theHTML.replace("[VIDEO_ID]", video_id);
        theHTML = theHTML.replace("[VIDEO_ID]", video_id);
        if(video_type !== 'youtube') {
            jQuery('.gallery-main-video').html(theHTML);
        }
    }

    if (jQuery('.product-gallery-right').length) {
        // galleryChange();
    }


    if (jQuery("#profit-calculator").length) {

        jQuery('#scan_charge').bind('keyup', function(){
            jQuery(this).val(jQuery(this).val().replace(/[^0-9\.-]+/g,""));
            if (jQuery('#scans_per_month').val() != '') {
                var total = parseFloat(jQuery(this).val()) * parseInt(jQuery('#scans_per_month').val());
                jQuery("#profit-calculator p.profit span.profit_amount").html(number_format (total, 2, '.', ','));
            }
        });

        jQuery('#scans_per_month').bind('keyup', function(){
            jQuery(this).val(jQuery(this).val().replace(/\D/g,""));
            if (jQuery('#scan_charge').val() != '') {
                var total = parseFloat(jQuery('#scan_charge').val()) * parseInt(jQuery(this).val());
                jQuery("#profit-calculator p.profit span.profit_amount").html(number_format (total, 2, '.', ','));
            }
        });

    }

    if (jQuery('.gfield.upload-button').length) {
        jQuery('.gfield.upload-button').bind('change', function(){
            jQuery(this).find('.validation_message').removeClass('hidden');
            jQuery(this).addClass('has-file');
            if (jQuery(this).find('.uploaded-file-name').length) {
                jQuery(this).find('.uploaded-file-name').remove();
            }
            jQuery(this).find('label').after('<span class="uploaded-file-name">' + jQuery(this).find('input[type=file]')[0].files[0].name + '</span>');
            jQuery(this).find('.validation_message').addClass('hidden');
        });
    }

    if (jQuery('.mobile-account-nav-link').length) {
        jQuery('.mobile-account-nav-link').bind('click', function(e){
            jQuery('.woocommerce-MyAccount-navigation').toggleClass('active');
            e.preventDefault();
        });
    }

    if (jQuery('.trigger-guest-checkout-btn').length) {
        jQuery('.trigger-guest-checkout-btn').bind('click', function(e){
            jQuery('.guest_checkout').show();
            jQuery('.woocommerce-login-wrapper').hide();
            e.preventDefault();
        });
    }

    jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
        if (jQuery('.trigger-guest-checkout-btn').length) {
            setCookie('resume-checkout', 1, 0.03);
        }
        if (jQuery('.gform_confirmation_message a.resend-email-link').length) {
            setCookie('modal-message-dismissed', 1, 365);
            console.log('form successfully submitted');
            jQuery('.gform_confirmation_message a.resend-email-link').bind('click', function(e){
                jQuery('.gform_confirmation_wrapper .error-message').slideUp(function(){
                    jQuery(this).remove();
                });
                var data = {
                    'action': 'resend_activation_email',
                    'reference': jQuery(this).data('ref')
                }
                $.post(ajax_url_object.ajax_url, data, function (response) {
                    var message = jQuery('<div>');
                    if (response.message == 'success') {
                        message.addClass('success-message');
                        message.html('Your email was successfully re-sent, please check your inbox');
                    } else {
                        message.addClass('error-message');
                        message.html('An unknown error has occured, please contact us on: <a href="tel:08081232020">0808 123 2020</a> if you continue to have problems setting up your account.');
                    }
                    jQuery('.gform_confirmation_message').before(message);
                    if (response.message == 'success') {
                        window.setTimeout(function () {
                            message.slideUp(function () {
                                jQuery(this).remove();
                            });
                        }, 7000);
                    }
                });
                e.preventDefault();
            }); 
        }
    });

    if (jQuery('#modal-message').length) {
        jQuery('#modal-message a.close-me').bind('click', function(){
            jQuery('#modal-message').removeClass('visible');
            setCookie('modal-message-dismissed', 1, 365);
        });
    }

    $('#mega-menu > li > a').on('click', function(e){
        if (!isTouchDevice()) {
            window.location.href = $(this).attr('href');
        }
    });

    // jQuery.post(ajaxurl,{'action': 'get_cart_total'},function(response){
    //     jQuery('#masthead .site-options .header-cta .cart-items').html(response);
    // });
    //
    // jQuery.post(ajaxurl,{'action': 'get_login_state'},function(response){
    //     jQuery('#masthead .site-options .header-cta a:first-child').html(response);
    // });

    jQuery('.global-site-banner .dismiss a').bind('click', function(e){
        jQuery('.global-site-banner').slideUp();
        setCookie('global-site-banner-dismissed', 1, 365);
        e.preventDefault();
    });

    if (jQuery('.global-site-banner').length && !getCookie('global-site-banner-dismissed')) {
        jQuery('.global-site-banner').addClass('active');
    }
}));

function init_ppecalculator() {
    var table = jQuery('.ppe_table');
    update_ppe_table(table);

    jQuery('.ppe-calculator-form').find('input').on('change', function() {
        update_ppe_table(table);
    });

    table.find('tr').each(function(indexTop, valueTop) {
        jQuery(this).find('td').each(function(index, value) {
            jQuery(this).click(function() {
                if(index === 0 || indexTop <= 1 || indexTop === 9) return; // Title cell

                jQuery(this).toggleClass('selected');

                jQuery(valueTop).find('td').not(jQuery(this)).each(function() {
                    jQuery(this).removeClass('selected');
                });
            });
        });
    });

    jQuery("a[href='#add_selected_to_cart']").click(function (e) {
        e.preventDefault();

        table.find('.selected').each(function() {
            var product_id = jQuery(this).parent().data('product-id');
            var quantity = parseInt(jQuery(this).text());

            jQuery('.add_to_cart_form').find('input[data-id="' + product_id + '"]').val(quantity);
        });

        table.promise().done(function() {
            if(jQuery('.selected').length <= 0) {
                alert('Please select your required items by clicking on the cells in the above table.');
                return;
            }

            jQuery('.add_to_cart_form').submit();
        });
    });
}

function update_ppe_table(table) {
    if(table === null) { console.log('Table not set.'); return; }
    var num_clinical_staff = parseInt(jQuery('.number-clinical-staff').val());
    var num_non_clinical_staff = parseInt(jQuery('.number-non-clinical-staff').val());
    var days_per_week_open = parseInt(jQuery('.days-per-week-open').val());
    var patients_per_day = parseInt(jQuery('.patients-per-day').val());

    if (num_clinical_staff === null ||
        num_non_clinical_staff === null ||
        days_per_week_open === null ||
        patients_per_day === null) {

        return; // If we don't have all info for calculations, don't proceed
    }

    jQuery('.ffp-2-masks').find('td').each(function(index, value) {
        if (index === 0) return; // Title cell

        update_cell_text(value, (num_clinical_staff * days_per_week_open) * index);
    });

    jQuery('.en-14683-llr-masks').find('td').each(function(index, value) {
        if (index === 0) return; // Title cell

        update_cell_text(value, ((num_non_clinical_staff * days_per_week_open) * 3) * index);
    });

    jQuery('.nitrile-gloves').find('td').each(function(index, value) {
        if (index === 0) return; // Title cell

        update_cell_text(value, patients_per_day * (num_clinical_staff + num_non_clinical_staff) * days_per_week_open * index);
    });

    jQuery('.disposable-aprons').find('td').each(function(index, value) {
        if (index === 0) return; // Title cell

        update_cell_text(value, patients_per_day * (num_clinical_staff + num_non_clinical_staff) * days_per_week_open * index);
    });

    jQuery('.face-shields-goggles').find('td').each(function(index, value) {
        if (index === 0) return; // Title cell

        update_cell_text(value, (num_clinical_staff * days_per_week_open) * index);
    });

    jQuery('.alcohol-hand-sanitiser').find('td').each(function(index, value) {
        if (index === 0) return; // Title cell

        update_cell_text(value, (num_clinical_staff + (num_non_clinical_staff / 2)) * index);
    });

    jQuery('.alcohol-surface-wipes').find('td').each(function(index, value) {
        if (index === 0) return; // Title cell

        update_cell_text(value, (num_clinical_staff + (num_non_clinical_staff / 4)) * index);
    });

    jQuery('.disposable-waste-bags').find('td').each(function(index, value) {
        if (index === 0) return; // Title cell

        // jQuery(value).text();
        update_cell_text(value, (days_per_week_open * (num_clinical_staff + 2)) * index);
    });
}

function update_cell_text(cell_object, value) {
    jQuery(cell_object).text(value);

    jQuery(cell_object).addClass('flash').delay(100).queue(function(next){
        jQuery(this).removeClass("flash");
        next();
    });
}